export default [
  {
    value: 1,
    text: '手动发货'
  },
  {
    value: 2,
    text: '机器人发货'
  },
  {
    value: 3,
    text: '扎比特发货(人工手动)'
  },
  {
    value: 4,
    text: '扎比特发货(自动脚本)'
  }
]
